import { AxiosResponse } from "axios";
import { CalcularMontosDto } from "../models/participantes";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { CoberturaPoliza, SeguroDeudor } from "../models/seguroDeudor";
import { selectorTransversal } from "../../../dtos/selector";

const getSegurosPorPoliza = async (codigoPoliza: string, codigoHijo: string) => {
    const params = new URLSearchParams({
        codigoPoliza: codigoPoliza ?? "",
        codigoHijo: codigoHijo ?? ""
    });

    const url = `siscred-api-participantes/v1/seguros-participantes-mutuo/obtener-seguro?${params.toString()}`;

    return axiosInstance.get(url);
};

const getCodigosPoliza = async (tipoSeguro: string) => {
    const params = new URLSearchParams({
        tipoSeguro: tipoSeguro ?? ""
    });

    const response: AxiosResponse<ListResponseDto<selectorTransversal>> = await axiosInstance.get(
        `siscred-api-participantes/v1/seguros-participantes-mutuo/obtener-codigo-poliza?${params.toString()}`
    );
    return response;
};

const GetCodPolizasHijo = async (codigo: string, tipoSeguro: string) => {
    const params = new URLSearchParams({
        codigo: codigo ?? "",
        tipoSeguro: tipoSeguro ?? ""
    });

    const response: AxiosResponse<ListResponseDto<selectorTransversal>> = await axiosInstance.get(
        `siscred-api-participantes/v1/seguros-participantes-mutuo/obtener-poliza-hijo?${params.toString()}`
    );
    return response;
};

const calculoMontoSeguro = async (dataRequest: CalcularMontosDto) => {
    const response: AxiosResponse = await axiosInstance.post(
        `siscred-api-participantes/v1/seguros-participantes-mutuo/calcular-monto-asegurado`,
        dataRequest
    );
    return response;
};


const getSegurosDeudor = async (mutuoId: number) => {
    const response: Promise<AxiosResponse<ListResponseDto<SeguroDeudor>>> = axiosInstance.get(`siscred-api-participantes/v1/seguros-participantes-mutuo/obtener-seguros-deudor?mutuoId=${mutuoId}`);

    return response;
}

const getSeguroDeudor = async (mutuoId: number, seguroId: number) => {

    const response: AxiosResponse = await axiosInstance.get(`siscred-api-participantes/v1/seguros-participantes-mutuo/obtener-seguro-deudor?mutuoId=${mutuoId}&seguroId=${seguroId}`);

    return response;
}


const getCoberturasPolizas = async (codigo: string, codigoInterno: string) => {

    const response: AxiosResponse<ListResponseDto<CoberturaPoliza>> = await axiosInstance.get(`siscred-api-participantes/v1/seguros-participantes-mutuo/listar-cobertura?codigo=${codigo}&codigoInterno=${codigoInterno}`);

    return response;
}

export {
    getSegurosPorPoliza,
    getCodigosPoliza,
    GetCodPolizasHijo,
    calculoMontoSeguro,
    getSegurosDeudor,
    getSeguroDeudor,
    getCoberturasPolizas
}